import React from "react";
import fssc22000Img from "../../../assets/Images/certificates/fssc-22000.svg";
import brosImg from "../../../assets/Images/certificates/bros.svg";
import fdaImg from "../../../assets/Images/certificates/fda.svg";
import haccpImg from "../../../assets/Images/certificates/haccp.svg";
import cgmpImg from "../../../assets/Images/certificates/cgmp.svg";
import isoImg from "../../../assets/Images/certificates/iso.svg";
import gmpImg from "../../../assets/Images/certificates/gmp.svg";
export default function Second_AboutUs_Section({
  certifications = [
    { id: 1, name: 'FSSC 22000', imageSrc: fssc22000Img },
    { id: 2, name: 'BRCGS', imageSrc: brosImg },
    { id: 3, name: 'FDA', imageSrc: fdaImg },
    { id: 4, name: 'HACCP', imageSrc: haccpImg },
    { id: 5, name: 'CGMP', imageSrc: cgmpImg },
    { id: 6, name: 'ISO', imageSrc: isoImg },
    { id: 8, name: 'GMP', imageSrc: gmpImg },

  ],
}) {
  // Duplicate for seamless looping
  const duplicatedCerts = [...certifications, ...certifications];

  return (
    <section className="w-full bg-[#F2F6EF] py-12 md:py-16">
      <style>{`
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .marquee-container {
          overflow: hidden;
          width: 100%;
        }
        .marquee {
          display: flex;
          gap: 2rem;
          animation: marquee 10s linear infinite;
        }
        .marquee:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Certification Badges Container */}
        <div className="bg-white rounded-2xl py-8 px-6 sm:px-8 lg:px-12 shadow-sm">
          <div className="marquee-container">
            <div className="marquee">
              {duplicatedCerts.map((cert, idx) => (
                <div
                  key={idx}
                  className="flex-shrink-0 h-24 sm:h-28 w-24 sm:w-28 flex items-center justify-center"
                >
                  {cert.imageSrc ? (
                  <div className="shine">
                      <img
                      src={cert.imageSrc}
                      alt={cert.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  ) : (
                    <div className="text-center">
                      <div className="text-2xl sm:text-3xl font-bold" style={{ color: '#335235' }}>
                        {cert.name.charAt(0)}
                      </div>
                      <p className="text-xs sm:text-sm font-semibold" style={{ color: '#335235' }}>
                        {cert.name}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
